// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_13pix","hidden":"_34dfb","timeWrapper":"_1xYwV","time":"_1Lg1w","duration":"_3O4vl","liveMode":"_1hg5A","separator":"_29ctX"};